import React, {createElement, FC} from 'react'
import {Route} from 'react-router-dom'
import {RouteParam} from './RouteParam'

interface MiddlewareParam {
  route: keyof RouteParam
  path: string
  exact: boolean
  component: FC<any>
  relativePath: string
}

export default function Middleware({
  route,
  path,
  component,
  exact = true,
  relativePath,
}: MiddlewareParam) {
  return (
    <Route key={route} path={`${relativePath}${path}`} exact={exact}>
      {createElement(component, undefined, undefined)}
    </Route>
  )
}
